<template>
  <div class="photo-card">
    <div class="photo-wrapper" @click="openViewer">
      <img
        :src="photoUrl"
        :data-source="photoUrl"
        :alt="attendance.name"
        class="photo-image"
        v-lazy="{
          src: photoUrl,
          error: defaultPhoto,
          loading: loadingImage
        }"
        @error="handleImageError"
      />
      
      <div class="photo-overlay">
        <Icon type="ios-expand" size="20" class="expand-icon" />
      </div>
    </div>
    
    <div class="card-info">
      <div class="employee-name" :title="attendance.name">
        {{ attendance.name }}
      </div>
      
      <div class="info-row">
        <Icon type="ios-time" size="11" />
        <span>{{ attendance.timescan }}</span>
      </div>
      
      <div class="info-row">
        <Icon type="ios-card" size="11" />
        <span>{{ attendance.card_id || 'N/A' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AttendancePhotoCard',
  props: {
    attendance: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      imageError: false,
      defaultPhoto: require('@/assets/default_user.jpg'),
      loadingImage: require('@/assets/Rolling-1s-200px_2.svg')
    }
  },
  computed: {
    photoUrl() {
      if (this.imageError) {
        return this.defaultPhoto
      }
      if (this.attendance.url) {
        return `/api/files?filePath=${this.attendance.url}`
      }
      return this.defaultPhoto
    }
  },
  methods: {
    handleImageError(e) {
      this.imageError = true
      if (e && e.target) {
        e.target.src = this.defaultPhoto
      }
    },
    openViewer() {
      this.$emit('open-viewer', this.attendance)
    }
  }
}
</script>

<style scoped lang="scss">
.photo-card {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
    transform: translateY(-2px);
    
    .photo-image {
      transform: scale(1.08);
    }
    
    .photo-overlay {
      opacity: 1;
    }
  }
  
  &:active {
    transform: translateY(0);
  }
  
  .photo-wrapper {
    position: relative;
    width: 100%;
    padding-top: 100%;
    overflow: hidden;
    
    .photo-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }
    
    .photo-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        to bottom,
        rgba(102, 126, 234, 0.6) 0%,
        rgba(118, 75, 162, 0.7) 100%
      );
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s ease;
      
      .expand-icon {
        color: white;
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
      }
    }
  }
  
  .card-info {
    padding: 8px;
    background: #fafafa;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    
    .employee-name {
      font-weight: 600;
      font-size: 11px;
      color: #17233d;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 1.3;
    }
    
    .info-row {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 10px;
      color: #808695;
      line-height: 1.2;
      
      i {
        flex-shrink: 0;
        color: #667eea;
      }
      
      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 500;
      }
    }
  }
}

@media (max-width: 768px) {
  .photo-card {
    &:hover {
      transform: none;
    }
    
    .card-info {
      padding: 6px;
      gap: 3px;
      
      .employee-name {
        font-size: 10px;
      }
      
      .info-row {
        font-size: 9px;
      }
    }
  }
}
</style>
